import { Link } from 'react-router-dom';
import { categories, categoryVideos } from '@/mocks/homeData';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            分类浏览
          </h2>
          <p className="text-sm text-foreground-500 mt-2">按类型发现更多精彩内容</p>
        </div>

        <div className="space-y-12">
          {categories.map((cat) => {
            const videos = categoryVideos[cat.slug];
            if (!videos) return null;
            return (
              <div key={cat.slug}>
                <div className="flex items-center justify-between mb-5">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-xl">
                      <i className={`${cat.icon} text-background-50 text-lg`}></i>
                    </div>
                    <div>
                      <h3 className="font-heading font-semibold text-lg text-foreground-900">{cat.name}</h3>
                    </div>
                  </div>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors cursor-pointer whitespace-nowrap"
                  >
                    更多 <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
                  {videos.map((video) => (
                    <Link
                      key={video.id}
                      to={`/category/${cat.slug}`}
                      className="group cursor-pointer"
                    >
                      <div className="relative aspect-video rounded-lg overflow-hidden mb-3">
                        <img
                          src={video.imageUrl}
                          alt={video.title}
                          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                          title={`${video.title} - 糖心视频在线观看`}
                        />
                        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                          <div className="w-10 h-10 flex items-center justify-center bg-primary-500/90 rounded-full">
                            <i className="ri-play-fill text-background-50 text-lg"></i>
                          </div>
                        </div>
                        <div className="absolute top-2 right-2">
                          <span className="bg-background-950/70 text-background-50 text-xs px-2 py-0.5 rounded-md backdrop-blur-sm">
                            {video.rating}
                          </span>
                        </div>
                      </div>
                      <h4 className="font-heading font-semibold text-sm text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1">
                        {video.title}
                      </h4>
                      <span className="text-xs text-foreground-500 mt-1">{video.views}次播放</span>
                    </Link>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}